import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { GetSecondHandSuppliesOrdersByPkService } from '../services/get-second-hand-supplies-orders-by-pk.service';

@Injectable({
  providedIn: 'root'
})
export class SecondHandSuppliesOrdersResolver implements Resolve<any> {
  /* ------------------------------- Constructor ------------------------------ */
  constructor(private getSecondHandSuppliesOrdersByPkService: GetSecondHandSuppliesOrdersByPkService){

  }
  /* --------------------------------- Resolve -------------------------------- */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.getSecondHandSuppliesOrdersByPkService.getSecondHandSuppliesOrdersByPk(route.paramMap.get('id'));
  }
}

